
import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'c-radio-button-label'
}

@Component(config)
export default class CRadioButtonLabel extends Vue {}
